module.exports = 
{
	header: `<div style="width: 75%; margin: 0 auto;">
		<h1 style="text-align: center; color: #777777; padding: 0; margin: .025em; font-size: 20px;">Label Declaration Sheet (LDS)</h1>
		<hr/>
		<h2 style="text-align: center; color: #777777; padding: 0; margin: .025em; font-size: 16px;">{ldsStatus}</h2>
		</div>`,
	body: `<html>
		<head>
			<meta http-equiv=Content-Type content="text/html; charset=windows-1252">
			<style>
				* { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
				table.borderless { border-collapse: separate; border-spacing: .5em; }
				table.borderless, table.borderless tr, table.borderless td { border: none; }
				td { padding: .25em .5em; }
				.highlight { background-color: #FF0; }
				.small { font-size: 12px; }
				.italic { font-style: italic; }
				.column-1 { width: 33%; }
				.column-2 { width: 67%; } 
			</style>
		</head>
		<body>
			<table class="borderless">
				<tr>
					<td class="column-1">PRODUCT Information:</td>
					<td class="column-2" style="color: red; font-size: 20px;">{productName}</td>
				</tr>
				<tr>
					<td class="highlight">Reason for Issuance:</td>
					<td>{productReason}</td>
				</tr>
			</table>
			<br/>
			<table border=1>
				<tr>
					<td class="column-1">Statement of Identity</td>
					<td class="column-2">{productSoi}</td>
				</tr>
				<tr>
					<td>Net Quantity of Contents</td>
					<td>{productNetQuantity}</td>
				</tr>
				<tr>
					<td>Front-of-Pack Declaration</td>
					<td>{productFrontOfPack}</td>
				</tr>
				<tr>
					<td>Juice Content</td>
					<td>{productJuiceStatement}</td>
				</tr>
				<tr>
					<td>Ingredient Statement</td>
					<td>{productIngredientStatement}</td>
				</tr>
				<tr>
					<td>Manufacturer’s Information</td>
					<td>{productManufacturerInfo}</td>
				</tr>
				<tr>
					<td>Country of Origin Statement</td>
					<td>{productCountryOfOrigin}</td>
				</tr>
				<tr>
					<td>Allergen Statement</td>
					<td>{productAllergenStatement}</td>
				</tr>
				{supplementedFoodFacts}
				<tr>
					<td>Front of Package Label</td>
					<td>{frontOfPackageLabel}</td>
				</tr>
				<tr>
					<td>NFP</td>
					<td>
						{nfp}
						<div>Please note the Nutrition Facts is not camera ready. Kindly use the correct template.</div>
					</td>
				</tr>
				<tr>
					<td>Claims, Qualifying Language</td>
					<td>
						{productNutrientContentClaim}<br/>
						{productQualifyingLanguage}<br/>
						{productOtherClaims}
					</td>
				</tr>
				<tr>
					<td>Other Label Information
						<span class="small">(i.e. Blend Statement; Warning or Advisory Statements; Caffeine info.; Organic info.; Reconstitution instructions; Storage/Use instructions;</span> <span class="highlight small italic">NOTE: Please make sure that the 1-800-telephone number for consumer inquiries is listed on the label.)</span>
					</td>
					<td>
						{productBlendStatement}<br/>
						{productCaffeineInformation}<br/>
						{productOrganicInformation}<br/>
						{productReconstitutionInstructions}<br/>
						{productStorageUseInstructions}<br/><br/>
						{productPkuWarningStatement}<br/><br/>
						{productConsumerInquiries}
					</td>
				</tr>
				<tr>
					<td>Kosher</td>
					<td>{productKosher}</td>
				</tr>
				<tr>
					<td>Label Code</td>
					<td>{productLabelCode}</td>
				</tr>
				<tr>
					<td>Notes</td>
					<td>{notes}</td>
				</tr>
			</table>
		</body>
	</html>`,
	footer: `<div style="width: 100%; text-align: center;">
		<table style="width: 100%; font-size: 9px;">
			<tr>
				<td style="width: 50%;">
					<h3 style="font-size: 9px;">SRA Mandatory Elements</h3>
				</td>
				<td style="width: 50%;"></td>
			</tr>
			<tr>
				<td style="font-size: 9px;">PRODUCT INFORMATION: {productName}</td>
				<td style="font-size: 9px;">BBN &amp; Issue Date: {formulaBbn} ({issueDate})</td>
			</tr>
			<tr>
				<td style="font-size: 9px;">Label Code: {productLabelCode} - Revised Date: {revisedDate}</td>
				<td style="font-size: 9px;">BBN Replacing: {replaceBbn}</td>
			</tr>
			<tr>
				<td style="font-size: 9px;">SFDC Link: {sfdcProductLink}</td>
			</tr>
		</table>
		<div style="text-align: center">
			<h3 style="font-size: 10px;">Classified - Confidential</h3>
		</div>
	</div>`
}